module.exports = " <div class=asset-upload-listing> <div class=asset-upload-listing-header> <h6>{{ translate_choice('cp.uploads', uploads.length) }}</h6> </div> <table> <tbody> <tr is=upload v-for=\"(i, upload) in uploads\" :basename=upload.basename :extension=upload.extension :percent=upload.percent :error=upload.errorMessage @clear=clearUpload(i)> </tr> </tbody> </table> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/assets/Uploads.vue
// module id = 286
// module chunks = 0